<template>
  <div> 

    <full-page ref="fullpage" id="fullpage"  :options="options">
      
      <div class="section pan-row">
        <app-header></app-header>
        <v-layout>

          <v-flex xs-6 style="background:white;">
            <div class="platter-left-container">
              <transition name="platter-left">
                <div v-if="show"> 
                  <img  src="../assets/images/all/platter-left.png" alt="">
                </div>
              </transition>
            </div>
          </v-flex>

          <v-flex xs-6 style="background:black;">
            <div class="platter-right-container">
              <transition name="platter-right">
                <div v-if="show">
                  <img src="../assets/images/all/platter-right.png" alt="">
                </div>
              </transition>
            </div>
          </v-flex>
        </v-layout>
        <transition name="reveal">
          <h2 v-if="showTitle" class="page-header">
            <span>
              <img src="../assets/images/all/r-retinoate.png" alt="">
              <!-- r-Retinoate<span>&reg;</span> -->
              </span>
            <span>{{ $t("masterpiecePage.firstSection.header") }}</span>
          </h2>
        </transition>
        <div class='icon-scroll' style="bottom:20px;"></div>
      </div>

      <div class="section bg-21-researchers">
          <section class="slide ">
            <v-container fill-height>
              <v-layout row align-center justify-center>
                <v-flex class="ma-4">

                  <div class="pan-story-container text-xs-center" >
                    <h2>{{$t('masterpiecePage.slide1.header')}}</h2>
                    <p class="pb-3">{{$t('masterpiecePage.slide1.paragraph')}}</p> 
                  </div>

                </v-flex>
              </v-layout>
            </v-container>
          </section>

          <section class="slide bg-encapsulation-perfection">
            <v-container fill-height>
              <v-layout row align-center justify-center>
                <v-flex class="ma-4">

                  <div class="pan-story-container text-xs-center" >
                    <h2>{{$t('masterpiecePage.slide2.header')}}</h2>
                    <p class="pb-3">{{$t('masterpiecePage.slide2.paragraph')}}</p> 
                  </div>

                </v-flex>
              </v-layout>
            </v-container>
          </section>

          <section class="slide bg-guaranteed-freshness">
            <v-container fill-height>
              <v-layout row align-center justify-center>
                <v-flex class="ma-4">

                  <div class="pan-story-container text-xs-center" >
                    <h2>{{$t('masterpiecePage.slide3.header')}}</h2>
                    <p class="pb-3">{{$t('masterpiecePage.slide3.paragraph')}}</p> 
                  </div>

                </v-flex>
              </v-layout>
            </v-container>
          </section>

      </div>

      <app-footer class="fp-auto-height" :top="this.$t('masterpiecePage.tooltips.one')"></app-footer>
    </full-page>


  </div>
</template>

<script>
import appHeader  from '../components/app-header.vue'
import appFooter  from '../components/app-footer.vue'
import appPercentage from '../components/app-percentage.vue'

export default {
  data: function(){
    return {
      show:false,
      showTitle:false,
      options: {
        anchors:[
          this.$t('masterpiecePage.tooltips.one'),
          this.$t('masterpiecePage.tooltips.two'),
          this.$t('masterpiecePage.tooltips.three')
        ],
        navigation: true,
        navigationTooltips: [ 
          this.$t('masterpiecePage.tooltips.one'),
          this.$t('masterpiecePage.tooltips.two'),
          this.$t('masterpiecePage.tooltips.three')
        ],
        showActiveTooltip: true,
        verticalCentered: false,
        scrollBar: true,
        fitToSection:true,
        slidesNavigation: true,
        navigation: true,
        afterLoad: this.afterLoad,
        // licence Key
        licenseKey: this.$licenceKey
      }
    }
  },
  components: {
    appHeader,
    appFooter,
    appPercentage
  },
  methods:{
    afterLoad() {
      var masterpieceThis = this;
      setTimeout(function(){
        masterpieceThis.show = true;
        masterpieceThis.showTitleMethod();
      }, 500);
    },
    showTitleMethod(){
      var masterpieceThis = this;
      setTimeout(function(){
        masterpieceThis.showTitle = true;
      }, 2000);
    }
  }
}
</script>


<style lang="scss" scoped>
@import "../assets/styles/_vars";

h2 {
  padding: 20px 0px;
}
.pan-story-container {
  background: rgba(255, 255, 255, 0.9);
  max-width: 700px;
  margin: 20px auto;
  padding: 20px;
  @media screen and (min-width: $l-screens) {
    padding: 80px 100px 100px 100px;
  }
}

.page-header {
  white-space: nowrap;
  text-align: center;
  span {
    position: relative;
    bottom: -25px;
    display: block;
    &:first-child {
      text-transform: none;
      img {
        max-width: 250px;
      }
      span {
        display: inline;
        right: 0px;
        top: -5px;
        font-size: 12px;
        @media screen and (min-width: $m-screens) {
          top: -15px;
          font-size: 16px;
        }
      }
    }
    &:last-child {
      font-size: 10px;
      @media screen and (min-width: $m-screens) {
        font-size: 14px;
      }
    }
  }
  white-space: nowrap;
  padding: 10px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.platter-left-container,
.platter-right-container {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & > div {
    img {
      width: 200%;
      padding: 20px;
      @media screen and (min-width: $xs-screens) {
        padding: 40px;
      }
      @media screen and (min-width: $s-screens) {
        padding: 100px;
      }
      @media screen and (min-width: $m-screens) {
        width: 100%;
        max-width: 800px;
      }
      @media screen and (min-width: $l-screens) {
        padding: 60px;
      }
      @media screen and (min-width: $l2-screens) {
        padding: 20px;
      }
    }
    position: relative;
    bottom: -50px;
  }
}

.platter-left-container {
  & > div {
    left: 0%;
    @media screen and (min-width: $m-screens) {
      left: 50%;
    }
  }
}

.platter-right-container {
  & > div {
    right: 100%;
    @media screen and (min-width: $m-screens) {
      right: 50%;
    }
  }
}

.platter-left-enter {
  transition: all 2s ease-out;
  transform: translate(-100%);
}

.platter-left-enter-to {
  transition: all 2s ease-out;
  transform: translate(0%);
}

.platter-right-enter {
  transition: all 2s ease-out;
  transform: translate(100%);
}

.platter-right-enter-to {
  transition: all 2s ease-out;
  transform: translate(0%);
}

.reveal-enter {
  transition: all 3s ease-out;
  opacity: 0;
}

.reveal-enter-to {
  transition: all 3s ease-out;
  opacity: 1;
}
</style>
